import React from 'react';
import Star from './Star.jsx';

const ProductTileReviews = (props) => {
  const numStars = Math.round((props.review / 20) * 2) / 2;

  const stars = [];

  for (let i = 0; i < 5; i++) {
    if (numStars <= i) {
      stars.push(<Star key={`Star-${i}`} type="empty" />);
    } else if (numStars - i === 0.5) {
      stars.push(<Star key={`Star-${i}`} type="half" />);
    } else {
      stars.push(<Star key={`Star-${i}`} type="full" />);
    }
  }

  return <div className="ProductTileReviews">{stars}</div>;
};

export default ProductTileReviews;
